module.exports = __webpack_public_path__ + "static/media/google_scholar_icon.78e45921.png";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/google_scholar_icon.png
// module id = 86
// module chunks = 0